<script setup>
import { onMounted } from 'vue';
import router from '@/router';
import {initAppIfAuthenticated} from "@/shared/functions";

onMounted(async() => {
  await initAppIfAuthenticated()
  router.push({name: 'dashboardHeadOccupationalTherapyInfo'});
})
</script>

<template>
    <router-view></router-view>
</template>

<style scoped>

</style>
